import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';

import FabricSubCategory from '@components/commonFilters/materials/Fabrics/FabricSubCategory';
import CustomDropdown from '@components/CustomDropdown';
import LoaderComponent from '@components/LoaderComponent';
import { toastError, toastSuccess } from '@components/Toast';
import AddNewFabricType from '@components/materials/AddNewFabricType';

import UploadImage from '@features/designTool/components/UploadImage';
import MaterialColorAddV2 from '@features/materials/components/MaterialColorAddV2';
import MaterialRoadmap from '@features/materials/components/MaterialRoadmap';
import {
	CUTTABLE_WIDTH_TYPES,
	FABRIC_BASE_LIST,
	FABRIC_QTY_TYPES,
	NITEX_RND_LIST,
	PRICE_POINT_LIST,
	PURCHASE_PRICE_TYPES,
	STRIPE_TYPES,
	WEIGHT_TYPES
} from '@features/materials/MaterialConstants';

import {
	getBrands,
	getFabricComposition as fetchFabricComposition,
	getFabricPatterns,
	getFabricTypes as fetchFabricTypes
} from '@store/design/action';
import { fetchFabricDetails } from '@store/material/action';
import { getAllBrands, getAllFabricPatterns, getCommonFilters, getMaterialsDetails } from '@store/reducers';
import { fetchAllTags, updateSearchResultForFabric } from '@store/supplier/action';

import { fetchMaterialUnitType } from '@services/commonService';

import ApiClient from '@lib/apiClient';

import {
	areEqual,
	compositionCalculation,
	compositionDefaultFieldSet,
	docType,
	FABRIC_TYPE_LIST,
	fetchCompositionNameList,
	fetchSupplierByMaterialType,
	getFabricCategory,
	onChangeCompositionPercentage,
	onChangeCompositionSelection,
	onGetFabricTypeList
} from '@utils/MaterialsUtil';
import {
	_getKey,
	capitalizeFirstLetter,
	changeDateFormat,
	checkAnyUserType,
	isValidFile,
	printApiError,
	validateFloatNumber
} from '@utils/Util';

import { BASE_URL, MATERIALS_TYPE } from '@/constants/constant';

const Fabric = ({
	materialData,
	onclose,
	renderFrom,
	isAdd,
	viewType,
	onSubmitSuccess,
	setSelectedBalance,
	setSelectedSort
}) => {
	const [show, setShow] = useState(true);
	const [multipleImageData, setMultipleImageData] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [materialId, setMaterialId] = useState(null);
	const [errors, setErrors] = useState({});
	const [errors2, setErrors2] = useState({});
	const [selectedItem, setSelectedItem] = useState({});
	const [totalPercentage, setTotalPercentage] = useState(0);
	const [tags, setTags] = useState([]);
	const [selectedTags, setSelectedTags] = useState([]);
	const [fabricBase, setFabricBase] = useState({});
	const [nitexRND, setNitexRND] = useState({});
	const [pricePoint, setPricePoint] = useState({});
	const [fabricSubCategories, setFabricSubCategories] = useState([]);
	const [, setCompositionList] = useState([]);
	const [, setFabricType] = useState('');
	const [duplicateFabric, setDuplicateFabric] = useState({});
	const [duplicateValueSet, setDuplicateValueSet] = useState(true);
	const [compositionNameList, setCompositionNameList] = useState([]);
	const [compositionFieldInfoList, setCompositionFieldInfoList] = useState(
		compositionDefaultFieldSet(2, [])
	);
	const [isFabricTypeModify, setIsFabricTypeModify] = useState(false);
	const [isAddNew, setIsAddNew] = useState(false);
	const [selectedFabricTypeToEdit, setSelectedFabricTypeToEdit] = useState(null);
	const [addNewValue, setAddNewValue] = useState('');
	const [fabricTypeList, setFabricTypeList] = useState([]);
	const [selectedDrappy, setSelectedDrappy] = useState(null);
	const [selectedHandFeel, setSelectedHandFeel] = useState(null);
	const [selectedLook, setSelectedLook] = useState(null);
	const [selectedWeightType, setSelectedWeightType] = useState(null);
	const [selectedFinishEffect, setSelectedFinishEffect] = useState(null);
	const [cuttableWidthType, setCuttableWithType] = useState(null);
	const [stripeType, setStripeType] = useState(null);
	/* ------------- supplier ---------------------- */
	const [, setAllUnitTypes] = useState([]);
	const [referenceNumber, setReferenceNumber] = useState('');
	const [selectedBrands, setSelectedBrands] = useState([]);
	const [selectedSupplier, setSelectedSupplier] = useState(null);
	const [suppliers, setSuppliers] = useState([]);
	const [oldSupplierId, setOldSupplierId] = useState([]);
	const [duplicateSupplier, setDuplicateSupplier] = useState({});
	const [chalanNo, setChalanNo] = useState('');
	const [isImported, setIsImported] = useState(null);
	const [invoiceNo, setInvoiceNo] = useState('');
	const [purchasePrice, setPurchasePrice] = useState('');
	const [purchasePriceCurrencyType, setPurchasePriceCurrencyType] = useState(null);
	const [fabricQty, setFabricQty] = useState('');
	const [fabricQtyType, setFabricQtyType] = useState(null);
	const [fabricTypeResponse, setFabricTypeResponse] = useState([]);
	const commonfilters = useSelector(getCommonFilters);
	const [selectedFabricToEdit, setSelectedFabricToEdit] = useState(null);
	/*---------------------Roadmap---------------------*/
	const [roadmapInput, setRoadmapInput] = useState([]);
	const [colorId, setColorId] = useState(null);
	const [colorType, setColorType] = useState('SOLID');
	const [colorDTO, setColorDTO] = useState(null);
	const [colorGroupIdList, setColorGroupIdList] = useState([]);
	const [selectedPattern, setSelectedPattern] = useState({});
	const [selectedGroupColorList, setSelectedGroupColorList] = useState([]);
	const [selectedPantoneColorList, setSelectedPantoneColorList] = useState([]);

	const onTotalPercentage = (slt) => {
		let sum = slt?.reduce((acc, item) => acc + item.percentage, 0);
		setTotalPercentage(sum);
	};
	const dispatch = useDispatch();
	const tagType = 'MATERIAL_SUSTAINABLE_TAG';

	let fabricDetails = useSelector(getMaterialsDetails);
	if (isAdd) fabricDetails = null;

	useEffect(() => {
		if (selectedItem?.construction) {
			let value = selectedItem?.construction?.value;
			if (value) {
				setFabricType(FABRIC_TYPE_LIST.find((items) => value.includes(items.name))?.weightUnit);
			}
		}
	}, [selectedItem?.construction]);

	useEffect(() => {
		const inputState = [];
		const roadMapList = fabricDetails?.data?.supplierList || [];
		for (let i = 0; i < 5; i++) {
			inputState.push({
				supplier: roadMapList[i]?.name || null,
				leadTime: roadMapList[i]?.leadTimeInDays || null,
				moq: roadMapList[i]?.moq || null,
				unitPrice: roadMapList[i]?.price || null,
				unit: roadMapList[i]?.pricePerUnit || null,
				remarks: roadMapList[i]?.description || null,
				supplierId: roadMapList[i]?.supplierId || null,
				id: `SL-${i + 1}`,
				lastPriceModifiedAt: roadMapList[i]?.lastPriceModifiedAt || null
			});
		}
		setRoadmapInput(inputState);
	}, [fabricDetails]);
	const generateTagsArray = (tags, key) => {
		return tags.map((item) => {
			return {
				id: item?.id,
				value: item?.text,
				type: item?.type,
				key
			};
		});
	};

	const fetchTags = () => {
		ApiClient.GET('fetchFixedTags')
			.then(({ data }) => {
				let drappyTags = data.filter((item) => item.type === 'SUPPLIER_CHARACTERISTIC_DRAPPY');
				let handFeelTags = data.filter((item) => item.type === 'SUPPLIER_CHARACTERISTIC_HAND_FEEl');
				let finishEffectTags = data.filter(
					(item) => item.type === 'SUPPLIER_CHARACTERISTIC_FINISH_EFFECT'
				);
				let lookTags = data.filter((item) => item.type === 'SUPPLIER_CHARACTERISTIC_LOOK');
				let finishAndWashTags = data.filter(
					(item) => item.type === 'SUPPLIER_FINISH' || item.type === 'SUPPLIER_WASH'
				);
				setTags({
					drappy: generateTagsArray(drappyTags, 'drappy'),
					handFeel: generateTagsArray(handFeelTags, 'handFeel'),
					finishEffect: generateTagsArray(finishEffectTags, 'finishEffect'),
					finishAndWash: finishAndWashTags,
					look: generateTagsArray(lookTags, 'look')
				});
			})
			.catch((err) => {
				toastError(err.response.data.message);
			});
	};

	const allPatterns = useSelector(getAllFabricPatterns)?.map((item) => ({
		id: item.id,
		value: item.name,
		documentResponse: item.documentResponse
	}));

	useEffect(() => {
		dispatch(getFabricPatterns());
	}, [dispatch]);

	const getPatternCard = (item) => {
		return `<div class="item-with-logo">
				<img src="${item?.documentResponse?.docUrl}" alt="" />
				<span>${item.value}</span>
			</div>`;
	};

	useEffect(() => {
		if (renderFrom === 'MATERIAL') {
			fetchTags();
		}
		dispatch(fetchAllTags('', tagType));
		dispatch(fetchFabricTypes()).finally(() => {});

		dispatch(fetchFabricComposition()).finally(() => {});
		fetchSupplierByMaterialType(undefined, MATERIALS_TYPE.FABRIC, setIsLoading, setSuppliers).finally(
			fetchMaterialDetails()
		);
		onGetFabricSubCategory().finally();
	}, [materialData]);

	const getCompositionPartList = (itemDetails) => {
		return itemDetails?.compositionPartList?.map((item) => {
			return {
				id: item.id,
				text: `${item.percentage}% ${item.fiberName}`,
				value: item.id,
				label: `${item.percentage}% ${item.fiberName}`,
				percentage: item.percentage
			};
		});
	};

	const onGetgFabricSubCategory = async () => {
		await ApiClient.GET('getFabricSubCategory')
			.then(({ data }) => {
				if (data) {
					let subCategories = data?.map((item) => {
						return {
							id: item.id,
							value: item.name
						};
					});
					setFabricSubCategories(subCategories);
				}
			})
			.catch(({ response }) => {
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	useEffect(() => {
		onGetgFabricSubCategory();
		onGetFabricCompositions();
	}, []);

	const getFixedTagResponse = (type, item) => {
		switch (type) {
			case 'SUPPLIER_CHARACTERISTIC_DRAPPY':
				setSelectedDrappy({ ...item, value: item?.text });
				break;
			case 'SUPPLIER_CHARACTERISTIC_HAND_FEEl':
				setSelectedHandFeel({ ...item, value: item?.text });
				break;
			case 'SUPPLIER_CHARACTERISTIC_FINISH_EFFECT':
				setSelectedFinishEffect({ ...item, value: item?.text });
				break;
			case 'SUPPLIER_CHARACTERISTIC_LOOK':
				setSelectedLook({ ...item, value: item?.text });
				break;
			default:
				break;
		}
	};

	useEffect(() => {
		if (colorType === 'SOLID') {
			setSelectedPattern({});
		}
	}, [colorType]);

	useEffect(() => {
		const itemDetails = fabricDetails?.data;

		if (itemDetails !== undefined && itemDetails !== null) {
			const supplier =
				itemDetails?.supplierList && itemDetails?.supplierList.length && itemDetails?.supplierList[0];
			setMaterialId(itemDetails?.id);
			if (itemDetails?.documentResponseList) {
				setMultipleImageData(itemDetails.documentResponseList);
			}
			let supplierFinishList = [];
			if (itemDetails?.fixedTagResponseList) {
				setSelectedTags(itemDetails.fixedTagResponseList);
				for (let item of itemDetails.fixedTagResponseList) {
					if (item.type === 'SUPPLIER_FINISH' || item.type === 'SUPPLIER_WASH') {
						supplierFinishList.push({
							id: item.id,
							text: item.text,
							value: item.id,
							label: item.text
						});
					}
				}
			}
			setSelectedPattern(itemDetails?.fabricPatternResponse);
			setColorId(itemDetails?.materialColorResponse?.colorResponse?.id);
			setSelectedGroupColorList(itemDetails?.materialColorResponse?.colorGroupResponseList);
			setColorType(itemDetails?.materialColorResponse?.colorType?.constant);
			const selectedStripeType = STRIPE_TYPES.find((type) => type.id === itemDetails?.stripeType);
			setStripeType(selectedStripeType);
			if (Object.keys(itemDetails.materialColorResponse.colorResponse).length > 0) {
				if (itemDetails?.materialColorResponse?.colorResponse?.compositeColorList) {
					setSelectedPantoneColorList(
						itemDetails?.materialColorResponse?.colorResponse?.compositeColorList
					);
				} else {
					setSelectedPantoneColorList([itemDetails?.materialColorResponse?.colorResponse]);
				}
			} else {
				setSelectedPantoneColorList([]);
			}

			const tagResponseList = itemDetails?.fixedTagResponseList || [];
			tagResponseList.forEach((tagResponse) => {
				getFixedTagResponse(tagResponse?.type, tagResponse);
			});

			const findQtyType = FABRIC_QTY_TYPES.find((item) => item.id === itemDetails?.fabricQtyType);

			const findPurchasePriceType = PURCHASE_PRICE_TYPES.find(
				(item) => item.id === itemDetails?.purchasePriceType
			);

			const fabricBaseItem = FABRIC_BASE_LIST.find((item) => item.id === itemDetails?.fabricBase);

			const nitexRNDItem = NITEX_RND_LIST.find((item) => item.id === itemDetails?.isNitexRnd);

			const pricePointItem = PRICE_POINT_LIST.find((item) => item.id === itemDetails?.pricePoint);

			setChalanNo(itemDetails.chalanNO ? itemDetails.chalanNO : '');
			setInvoiceNo(itemDetails.invoiceNo ? itemDetails.invoiceNo : '');
			setFabricQty(itemDetails.fabricQty ? itemDetails.fabricQty : '');
			setFabricQtyType(findQtyType ? findQtyType : null);
			setPurchasePrice(itemDetails.purchasePrice ? itemDetails.purchasePrice : '');
			setPurchasePriceCurrencyType(findPurchasePriceType ? findPurchasePriceType : null);

			setFabricBase(fabricBaseItem);
			setNitexRND(nitexRNDItem);
			setPricePoint(pricePointItem);
			onTotalPercentage(getCompositionPartList(itemDetails));
			setIsImported(itemDetails?.isImported ? { id: 'YES', value: 'Yes' } : { id: 'NO', value: 'NO' });

			let fabricItemInfo = {
				...selectedItem,
				// colorResponseList: itemDetails?.colorResponseList || [],
				// fabricBase: itemDetails?.fabricBase,
				construction: fabricSubCategories?.find((item) => item.value === itemDetails?.construction),
				yarnCount: itemDetails?.yarnCount,
				gsm: itemDetails?.gsm,
				cuttableWidth: itemDetails?.cuttableWidth,
				description: itemDetails?.description || '',
				fabricFormula: itemDetails?.fabricFormula || '',
				finishAndWash: supplierFinishList,
				constructionDetails: itemDetails?.constructionDetails || '',
				// isNitexRnd: itemDetails?.isNitexRnd === true ? 'Yes' : 'No',
				documentId: itemDetails?.documentId || null,
				materialType: 'MAIN_FABRIC',
				id: itemDetails?.id,
				compositionPart: {
					id: itemDetails?.compositionDetails,
					text: itemDetails?.compositionDetails,
					value: itemDetails?.compositionDetails,
					label: itemDetails?.compositionDetails
				},
				stripeTypeDetails: itemDetails?.stripeTypeDetails || '',
				compositionPartList: itemDetails?.compositionPartList?.map((item) => item.id),
				tagRequestList: itemDetails?.tagResponseList?.map((item) => {
					return {
						id: item.id,
						text: item.text,
						value: item.id,
						label: item.text
					};
				})
			};
			if (
				itemDetails?.compositionPartList !== undefined &&
				itemDetails?.compositionPartList.length > 0
			) {
				let modulus = itemDetails?.compositionPartList.length % 2;
				let length =
					modulus === 0
						? itemDetails?.compositionPartList.length
						: itemDetails?.compositionPartList.length + 1;
				setCompositionFieldInfoList(
					compositionDefaultFieldSet(length, itemDetails?.compositionPartList)
				);
			}
			setSelectedItem(fabricItemInfo);

			if (supplier) {
				const oldIds =
					(itemDetails?.supplierList &&
						itemDetails?.supplierList.length > 0 &&
						itemDetails?.supplierList.map((item) => item?.supplierId)) ||
					[];

				setOldSupplierId(oldIds);
				setReferenceNumber(supplier.referenceNumber);
				setSelectedSupplier({ ...supplier, value: supplier?.name });
				setSelectedWeightType({
					id: itemDetails?.weightType,
					value: itemDetails?.weightType
				});
				setCuttableWithType({
					id: itemDetails?.cuttableWidthType,
					value: itemDetails?.cuttableWidthType
				});

				let brands = [];
				for (let item of supplier.brandResponseList) {
					brands.push({
						id: item.id,
						text: item.name,
						value: item.id,
						label: item.name
					});
				}
				setSelectedBrands(brands);
			}
			if (
				viewType === 'Duplicate' &&
				duplicateValueSet &&
				itemDetails?.id === materialData.id &&
				fabricItemInfo?.construction
			) {
				setOldSupplierId([]);
				setColorDTO({});
				if (itemDetails?.colorResponseList?.length > 0) {
					let colorResponse = itemDetails?.colorResponseList[0];
					setColorDTO(colorResponse);
				}

				let dupFabric = setFabricInfo(
					fabricItemInfo,
					fabricBaseItem,
					nitexRNDItem,
					pricePointItem,
					itemDetails?.fixedTagResponseList,
					itemDetails?.documentResponseList
				);
				let brandIdList = supplier?.brandResponseList.map((brand) => brand.id);
				let dupSupplier = {
					supplierId: supplier?.supplierId || null,
					referenceNumber: supplier?.referenceNumber,
					price: supplier?.price || null,
					pricePerUnit: supplier?.pricePerUnit || null,
					leadTimeInDays: supplier?.leadTimeInDays || null,
					moq: supplier?.moq || null,
					brandIds: brandIdList || []
				};
				setDuplicateFabric(dupFabric);
				setDuplicateSupplier(dupSupplier);
				if (supplier && fabricSubCategories) setDuplicateValueSet(false);
			}
			setIsLoading(false);
		} else {
			setIsLoading(false);
		}
	}, [fabricSubCategories, fabricDetails]);

	useEffect(() => {
		let supplier = fabricDetails?.data?.supplier;
		if (supplier && suppliers) supplierSet(supplier);
	}, [suppliers, fabricDetails?.data?.supplier]);

	const supplierSet = (supplier) => {
		let supplierNameInfo = suppliers.find((obj) => obj.id === supplier.supplierId);
		if (supplierNameInfo) {
			let item = { id: supplierNameInfo.id, title: 'Supplier', value: supplierNameInfo.value };
			setSelectedSupplier(item);
		}
	};

	const handleClose = (value) => {
		setSelectedItem(null);
		setShow(false);
		onclose(value);
		dispatch(updateSearchResultForFabric(null, false));
	};
	const multipleImageUpload = async (data) => {
		setIsLoading(true);
		await ApiClient.POST('getBulkUploadMaterialDoc', data)
			.then(({ data }) => {
				setIsLoading(false);
				if (data) {
					let docType = data.map((imageInfo) => imageInfo.docType);
					let tmpArray = multipleImageData?.filter((obj) => !docType.includes(obj.docType));
					if (tmpArray.length > 0) setMultipleImageData([...tmpArray, ...data]);
					else setMultipleImageData(data);
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};
	const singleImageUpload = async (imageInfo) => {
		delete imageInfo.productId;
		delete imageInfo.documentGroup;
		if (validateFileSize(imageInfo.size)) {
			imageInfo.entityId = materialData ? materialData?.id : null;
			setIsLoading(true);
			await ApiClient.POST('getUploadMaterialDoc', imageInfo)
				.then(({ data }) => {
					setIsLoading(false);
					if (data) {
						let tmpArray = multipleImageData?.filter((obj) => data.docType !== obj.docType);

						if (tmpArray?.length > 0) setMultipleImageData([...tmpArray, data]);
						else setMultipleImageData([data]);
					}
				})
				.catch(({ response }) => {
					setIsLoading(false);
					if (response && response.data && response.data.message) {
						toastError(response.data.message);
					} else {
						toastError('Request was unsuccessful.');
					}
				});
		}
	};
	const validateFileSize = (size) => {
		if (size > 1000000) {
			toastError('Please upload file less than 1mb');
			return false;
		} else {
			return true;
		}
	};
	const removeImage = async (docId) => {
		if (materialData?.id)
			await ApiClient.DELETE(
				`${BASE_URL}/material/${materialData?.id}/documents/${docId}`,
				'',
				'',
				true
			)
				.then(({ data }) => {
					setIsLoading(false);
					if (data && data.success) {
						toastSuccess(data.message);
						imageRemoveInArray(docId);
					}
				})
				.catch(({ response }) => {
					setIsLoading(false);
					if (response && response.data && response.data.message) {
						toastError(response.data.message);
					} else {
						toastError('Request was unsuccessful.');
					}
				});
		else {
			imageRemoveInArray(docId);
		}
	};
	const imageRemoveInArray = (docId) => {
		let tmpArray = multipleImageData?.filter((obj) => docId !== obj.id);
		setMultipleImageData(tmpArray);
	};
	const getImageData = (multipleImageData, documentType) => {
		return multipleImageData?.find((item) => item.docType === documentType);
	};

	const isValidMaterialRoadMap = () => {
		const roadmapList = roadmapInput.filter((roadmap) => {
			if (roadmap.supplier || roadmap.leadTime || roadmap.moq || roadmap.unitPrice || roadmap.unit) {
				return roadmap;
			}
		});
		const isValid = roadmapList.every(
			(roadmap) =>
				roadmap.supplier && roadmap.leadTime && roadmap.moq && roadmap.unitPrice && roadmap.unit
		);

		return isValid;
	};

	const isValidForm = (fabricInfo, supplierInfo) => {
		if (fabricInfo?.construction === undefined) {
			setErrors2({ ...errors2, constructionError: 'Fabric type is required' });
			return false;
		} else {
			setErrors2({ ...errors2, constructionError: undefined });
		}
		if (
			fabricInfo?.compositionPartList?.length === 0 ||
			fabricInfo.fabricCompositionPartIdList === undefined
		) {
			setErrors({ ...errors, compositionError: 'Total composition needs to be 100%' });
			return false;
		} else {
			setErrors({ ...errors, compositionError: undefined });
		}
		if (
			fabricInfo?.gsm === undefined ||
			fabricInfo?.gsm === null ||
			fabricInfo?.gsm.toString().trim() === ''
		) {
			setErrors2({ gsmError: 'Weight is required' });
			return false;
		}
		if (!selectedWeightType?.value) {
			setErrors2({ gsmError: 'Weight type is required' });
			return false;
		}

		if (!selectedItem?.cuttableWidth) {
			setErrors2({ cuttableWidthError: 'Cuttable Width is required' });
			return false;
		}
		if (colorType === 'YARN_DYED' && !stripeType?.id) {
			setErrors2({ stripeTypeError: 'Stripe type is required' });
			return false;
		}
		if (!cuttableWidthType?.value) {
			setErrors2({ cuttableWidthError: 'Select Cuttable width type ' });
			return false;
		}
		if (fabricInfo?.colorGroupIdList?.length === 0) {
			setErrors2({ colorError: 'Main color is required' });
			return false;
		}
		if (
			!selectedGroupColorList?.some((color) => color.isTransparent === true) &&
			selectedPantoneColorList?.length === 0
		) {
			setErrors2({ tcxColorError: 'TCX color is required' });
			return false;
		}
		if (colorType !== 'SOLID' && selectedGroupColorList?.length > 0 && !selectedPattern?.id) {
			setErrors2({ patternError: 'Pattern is required' });
			return false;
		}

		if (!selectedSupplier) {
			setErrors2({ supplierDetailsError: 'Supplier is Required' });
			return false;
		}
		if (supplierInfo?.supplierId === null) {
			setErrors2({ supplierError: 'Supplier is required' });
			return false;
		}

		if (!chalanNo) {
			setErrors2({ chalanError: 'Chalan No. is required' });
			return false;
		}

		if (!isImported) {
			setErrors2({ importError: 'Material Source Required' });
			return false;
		}
		if (!isValidMaterialRoadMap()) {
			setErrors2({ materialRoadmapError: 'Material Road map Required' });
			return false;
		}

		return true;
	};

	const addFabric = async (urlName, fabricInfo, supplierInfo) => {
		fabricInfo.colorDTO = colorDTO;
		fabricInfo.colorGroupIdList = colorGroupIdList;
		fabricInfo.materialType = 'MAIN_FABRIC';
		fabricInfo.colorType = colorType;
		if (colorType === 'YARN_DYED') {
			fabricInfo.stripeType = stripeType?.id;
		} else {
			delete fabricInfo.stripeTypeDetails;
		}
		if (colorType !== 'SOLID') {
			fabricInfo.fabricPatternId = selectedPattern?.id;
		}
		fabricInfo.addType = viewType;
		const isValid = isValidForm(fabricInfo, supplierInfo);
		if (!isValid) return;
		let fabricInfoWithSupplierInfo = {
			fabricRequest: fabricInfo,
			supplierMaterialRequestList: supplierInfo
		};
		setIsLoading(true);
		await ApiClient.POST(urlName, fabricInfoWithSupplierInfo)
			.then(({ data }) => {
				setIsLoading(false);
				if (data && data.success) {
					setSelectedBalance({ id: 'otherFabric', value: 'Other fabric' });
					setSelectedSort({ id: 'id,desc', value: 'New Arrival' });
					toastSuccess(data.message);
					handleClose('Add');
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const updatedFabric = async (fabricInfo, supplierInfo) => {
		fabricInfo.colorDTO = colorDTO;
		fabricInfo.colorGroupIdList = colorGroupIdList;
		fabricInfo.colorType = colorType;
		if (colorType === 'YARN_DYED') {
			fabricInfo.stripeType = stripeType?.id;
		} else {
			delete fabricInfo.stripeTypeDetails;
		}
		if (colorType !== 'SOLID') {
			fabricInfo.fabricPatternId = selectedPattern?.id;
		}
		const isValid = isValidForm(fabricInfo, supplierInfo);
		if (!isValid) return;
		let fabricInfoWithSupplierInfo = {
			updateFabricRequest: fabricInfo,
			supplierMaterialRequestList: supplierInfo
		};

		setIsLoading(true);
		await ApiClient.PUT('updateFabricWithSupplierDetails', fabricInfoWithSupplierInfo, materialId)
			.then(({ data }) => {
				setIsLoading(false);
				if (data && data.success) {
					toastSuccess(data.message);
					handleClose('updated');
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onGetFabricSubCategory = async (searchTerm = '') => {
		return await ApiClient.GET(
			'getFabricCompositions',
			`?pageSize=20&search=${searchTerm.replace('%', '')}`
		)
			.then(({ data }) => {
				if (data) {
					return data?.data?.map((item) => {
						if (parseInt(item.percentage) + totalPercentage > 100) {
							return {
								id: item.id,
								value: item.id,
								label: `${item.percentage}% ${item.fiberName}`,
								percentage: item.percentage,
								isDisable: true
							};
						} else {
							return {
								id: item.id,
								value: item.id,
								label: `${item.percentage}% ${item.fiberName}`,
								percentage: item.percentage,
								isDisable: false
							};
						}
					});
				}
			})
			.catch((error) => {
				printApiError(error);
			});
	};

	const onSubmit = () => {
		let compositionCalObj = compositionCalculation(compositionFieldInfoList);
		if (compositionCalObj.percentageIsNotOk) {
			setErrors({ ...errors, compositionError: 'Total composition needs to be 100%' });
			return false;
		} else if (compositionCalObj.fiberNameIsNotOk) {
			setErrors({ ...errors, compositionError: 'Select composition' });
			return false;
		} else {
			setErrors({ ...errors, compositionError: undefined });
			compositionPartChecking(compositionCalObj?.compositionPart).finally(() => {});
		}
	};

	const setFabricInfo = (
		selectedItem,
		fabricBase,
		nitexRND,
		pricePoint,
		selectedTags,
		multipleImageData
	) => {
		let fabricInfo = { ...selectedItem };
		let finishList = selectedItem?.finishAndWash?.map((item) => item.id) || [];
		fabricInfo.fabricCompositionPartIdList = selectedItem?.compositionPartList;
		let fixedTagList = [];
		if (
			selectedDrappy ||
			selectedHandFeel ||
			selectedFinishEffect ||
			selectedLook ||
			(finishList && finishList.length)
		) {
			fixedTagList = [
				selectedDrappy?.id,
				selectedHandFeel?.id,
				selectedFinishEffect?.id,
				selectedLook?.id,
				...finishList
			];
		}
		fabricInfo.weightType = selectedWeightType?.value;
		fabricInfo.fabricType = selectedItem?.construction?.fabricType;
		fabricInfo.chalanNo = chalanNo;
		fabricInfo.isImported = isImported?.value === 'Yes';
		fabricInfo.invoiceNo = invoiceNo || null;
		fabricInfo.purchasePrice = purchasePrice ? purchasePrice.toString() : ' 0';
		fabricInfo.purchasePriceType = purchasePriceCurrencyType?.value;
		fabricInfo.extraFabricType = selectedItem?.extraFabricType;
		fabricInfo.cuttableWidthType = cuttableWidthType?.value;
		fabricInfo.fabricQty = fabricQty || null;
		fabricInfo.fabricQtyType = fabricQtyType?.value;
		fabricInfo.fixedTagIdList = fixedTagList.filter((tag) => !!tag);
		fabricInfo.isNitexRnd = selectedItem?.isNitexRnd === 'Yes';
		fabricInfo.documentIdList = multipleImageData?.map((item) => item.id);
		fabricInfo.fabricBase = fabricBase?.id;
		fabricInfo.isNitexRnd = nitexRND?.id;
		fabricInfo.pricePoint = pricePoint?.id;
		fabricInfo.construction = selectedItem?.construction?.id;
		fabricInfo.materialType = 'MAIN_FABRIC';
		return fabricInfo;
	};

	const setSupplierInfo = () => {
		const formattedSupplierInfo = [];
		const supplierDetailsInfo = roadmapInput.map((item, index) => {
			if (index === 0) {
				return {
					...item,
					supplierId: selectedSupplier?.id || item?.supplierId
				};
			}
			return item;
		});

		supplierDetailsInfo.forEach((item, index) => {
			if (item.unitPrice && item.unit && item.leadTime && (item.supplierId || item?.supplier)) {
				formattedSupplierInfo.push({
					price: item?.unitPrice || null,
					pricePerUnit: item?.unit || null,
					oldSupplierId: oldSupplierId[index] || null,
					description: item?.remarks || null,
					leadTimeInDays: item?.leadTime || null,
					moq: item?.moq || null,
					moqUnit: item?.unit || null,
					brandIds: selectedBrands?.map((item) => item.id),
					materialId,
					referenceNumber: referenceNumber || null,
					supplierId: item?.supplierId,
					requestedPage: 'SUPPLIER'
				});
			}
		});
		return formattedSupplierInfo;
	};

	const onChangeMaterialRoadmap = (e, rowData, index) => {
		const { name, value } = e.target;

		setRoadmapInput((prev) => {
			return prev.map((item, i) => {
				if (i === index) {
					return {
						...rowData,
						[name]: value
					};
				}
				return item;
			});
		});
	};

	const isDuplicateDataCheck = (duplicateFabricInfo, fabricInfo, duplicateSupplier, supplierInfo) => {
		let isDuplicate = true;
		if (
			duplicateFabricInfo?.construction !== fabricInfo?.construction ||
			duplicateFabricInfo?.constructionDetails?.trim() !== fabricInfo?.constructionDetails?.trim() ||
			duplicateFabricInfo?.gsm !== fabricInfo?.gsm ||
			duplicateFabricInfo?.cuttableWidth !== fabricInfo?.cuttableWidth ||
			!areEqual(
				duplicateFabricInfo?.fabricCompositionPartIdList,
				fabricInfo?.fabricCompositionPartIdList
			) ||
			!areEqual(duplicateFabricInfo?.fixedTagIdList, fabricInfo?.fixedTagIdList) ||
			!areEqual(duplicateFabricInfo?.documentIdList, fabricInfo?.documentIdList) ||
			!areEqual(
				duplicateFabricInfo?.colorResponseList?.map((colorDTO) => colorDTO.name),
				colorDTO?.map((colorDTO) => colorDTO.name)
			) ||
			duplicateFabricInfo?.fabricBase !== fabricInfo?.fabricBase ||
			duplicateFabricInfo?.isNitexRnd !== fabricInfo?.isNitexRnd ||
			duplicateFabricInfo?.pricePoint !== fabricInfo?.pricePoint ||
			duplicateSupplier?.supplierId !== supplierInfo?.supplierId ||
			duplicateSupplier?.price !== supplierInfo?.price ||
			duplicateSupplier?.pricePerUnit !== supplierInfo?.pricePerUnit ||
			duplicateSupplier?.leadTimeInDays !== supplierInfo?.leadTimeInDays ||
			duplicateSupplier?.moq !== supplierInfo?.moq ||
			duplicateSupplier?.referenceNumber !== supplierInfo?.referenceNumber ||
			!areEqual(duplicateSupplier?.brandIds, supplierInfo?.brandIds)
		) {
			isDuplicate = false;
		}
		return isDuplicate;
	};

	const fetchMaterialDetails = () => {
		if (materialData !== null && materialData !== undefined) {
			setIsLoading(true);
			dispatch(fetchFabricDetails(materialData?.id)).finally(() => {
				setIsLoading(false);
			});
		}
	};

	const renderColors = () => {
		return (
			<>
				<MaterialColorAddV2
					colorId={colorId}
					setColorDTO={setColorDTO}
					colorType={colorType}
					setColorType={setColorType}
					setColorGroupIdList={setColorGroupIdList}
					selectedGroupColorList={selectedGroupColorList}
					setSelectedGroupColorList={setSelectedGroupColorList}
					selectedPantoneColorList={selectedPantoneColorList}
					setSelectedPantoneColorList={setSelectedPantoneColorList}
				/>
				{errors2?.colorError && <p className="error color-error">{errors2?.colorError}</p>}
				{errors2?.tcxColorError && <p className="error color-error">{errors2?.tcxColorError}</p>}
			</>
		);
	};

	const onFileUpload = (e) => {
		e.preventDefault();
		let files = [];
		let modifiedFileList = [];
		files = [...e.target.files];
		let invalidFiles = files.filter((item) => item.size > 1000000);
		if (invalidFiles.length > 0) {
			toastError('Each image size should be less than 1mb');
			return;
		}
		if (files.length !== 0 && invalidFiles.length === 0) {
			files.forEach((file) => {
				if (file) {
					if (isValidFile(file, 'image')) {
						let data = {
							entityId: materialData ? materialData?.id : null,
							name: file?.name,
							docMimeType: file?.type,
							documentType: 'MATERIAL_DESIGN',
							base64Str: '',
							size: file?.size
						};
						let reader = new FileReader();
						reader.readAsDataURL(file);
						reader.onload = () => {
							data.base64Str = reader.result;
							modifiedFileList.push(data);
						};
						reader.onerror = function (error) {
							toastError(error);
						};
					}
				}
			});
			setTimeout(() => {
				if (modifiedFileList?.length > 0) {
					multipleImageUpload(modifiedFileList).then().catch();
				}
			}, 100);
		}
	};

	const onChangeCategoryInfo = (selectedItems) => {
		setSelectedItem({
			...selectedItem,
			finishAndWash: selectedItems
		});
	};

	const renderFinishField = () => {
		let options = tags?.finishAndWash?.map((item) => ({
			id: item.id,
			text: item.text,
			value: item.id,
			label: item.text
		}));
		if (selectedItem?.finishAndWash?.length > 0) {
			return (
				<Select
					key={_getKey()}
					onChange={onChangeCategoryInfo}
					defaultValue={selectedItem?.finishAndWash}
					isMulti
					options={options}
				/>
			);
		} else {
			return <Select key={_getKey()} onChange={onChangeCategoryInfo} isMulti options={options} />;
		}
	};

	const onPriceRangeClick = (selectedItems) => {
		setPricePoint(selectedItems);
	};

	const onGetFabricCompositions = async (searchValue = '') => {
		return await ApiClient.GET(
			'getCompositionDetails',
			`?page=0&size=20&search=${encodeURIComponent(searchValue)}`
		)
			.then(({ data }) => {
				if (data) {
					let compositions = data.map((item) => {
						return {
							id: item,
							text: item,
							value: item,
							label: item
						};
					});
					setCompositionList(compositions);
				}
			})
			.catch(({ response }) => {
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const compositionPartChecking = async (selected) => {
		setIsLoading(true);
		if (selected)
			await ApiClient.GET('getCompositionParts', `?compositionDetails=` + encodeURIComponent(selected))
				.then(({ data }) => {
					setIsLoading(false);
					if (data.length === 0) {
						setErrors({ ...errors, compositionError: 'Composition is wrong' });
					} else {
						selectedItem.compositionPartList = data;
						let fabricInfo = setFabricInfo(
							selectedItem,
							fabricBase,
							nitexRND,
							pricePoint,
							selectedTags,
							multipleImageData
						);
						let supplierInfo = setSupplierInfo();
						if (viewType === 'Duplicate') {
							if (
								isDuplicateDataCheck(
									duplicateFabric,
									fabricInfo,
									duplicateSupplier,
									supplierInfo
								)
							) {
								toastError('Change the material info to add new fabric');
							} else {
								addFabric('duplicateFabricWithSupplier', fabricInfo, supplierInfo);
							}
						} else if (isAdd) {
							addFabric('addFabricWithSupplier', fabricInfo, supplierInfo);
						} else {
							updatedFabric(fabricInfo, supplierInfo);
						}
						setErrors({ ...errors, compositionError: undefined });
					}
					if (onSubmitSuccess) {
						onSubmitSuccess();
					}
				})
				.catch((error) => {
					setIsLoading(false);
					printApiError(error);
					if (error) {
						setSelectedItem({
							...selectedItem,
							compositionPartList: []
						});
						setErrors({ ...errors, compositionError: 'Composition is wrong' });
					}
				});
	};

	/** this method use for supplier side **/

	useEffect(() => {
		fetchMaterialUnitType().then((res) => {
			setAllUnitTypes(res);
		});
		fetchCompositionNameList(setCompositionNameList).finally();
		dispatch(getBrands()).finally(() => {
			setIsLoading(false);
		});
	}, []);

	let brands = useSelector(getAllBrands);
	brands = brands.map((item) => {
		return {
			id: item.id,
			text: item.name,
			value: item.name,
			label: item.name
		};
	});

	const onChangeBrandInfo = (selectedItems) => {
		setSelectedBrands(selectedItems);
	};
	const onItemClick = (item) => {
		setSelectedSupplier(item);
		setRoadmapInput((prev) => [...prev, (roadmapInput[0].supplier = item?.value)]);
	};
	const onAddNew = (value) => {
		setAddNewValue(value);
		getFabricCategory(setIsAddNew, setFabricTypeList);
	};

	const setNewFabricType = ({ data = {} }) => {
		if (!data) {
			return;
		}
		setSelectedItem({
			...selectedItem,
			construction: {
				id: data?.id,
				value: `${data?.fabricTypeConstant}-${data?.name}`,
				fabricType: data?.fabricType,
				name: data?.name
			}
		});
		setIsFabricTypeModify(true);
	};

	const onEditFabricType = (item) => {
		setSelectedFabricTypeToEdit(item);
		getFabricCategory(setIsAddNew, setFabricTypeList);
	};

	useEffect(() => {
		(async () => {
			const response = await onGetFabricTypeList(commonfilters);

			const findSelectedFabricType = response.find(
				(item) => item?.id === selectedItem?.construction?.id
			);
			setSelectedFabricToEdit(findSelectedFabricType);
		})();
	}, [selectedItem, commonfilters?.fabricTypes]);

	const compositionRender = (obj, index) => {
		return (
			<div className="col-md-6" key={_getKey()}>
				<div className="form-group composition-item mb-0">
					<div className="d-flex">
						<input
							type="number"
							defaultValue={obj?.percentage}
							min={0.1}
							max={100}
							onBlur={(e) =>
								onChangeCompositionPercentage(
									e.target.value,
									index,
									compositionFieldInfoList,
									setCompositionFieldInfoList
								)
							}
							className="input-percentage"
						/>
						<p className="percentage">%</p>
						<div className="select-component">
							<div className="form-group size36">
								<CustomDropdown
									type="fabricName"
									title={'Composition'}
									toolTipLength={13}
									onItemClick={(value) =>
										onChangeCompositionSelection(
											value,
											index,
											compositionFieldInfoList,
											setCompositionFieldInfoList
										)
									}
									items={compositionNameList}
									selectedItem={obj?.fiberName}
									searchPlaceholder="Composition"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	};

	return (
		<Modal show={show} onHide={handleClose} backdrop="static" centered className="new-matarial-add-popup">
			<LoaderComponent loading={isLoading}>
				<div className="common-popup new-fabric-popup">
					<Modal.Header closeButton>
						<Modal.Title className="w-100">
							<div className="popup-tilte d-flex align-items-center justify-content-between">
								<h3 className="semibold-16 mb-0">{viewType} Fabric</h3>
							</div>
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="common-popup-body scroll-y-label">
							<div className="common-fragment">
								<div className="dashboard-container material-images-uplodaer">
									<div className="presentations-tab">
										<div className="presentations-upload-image-container">
											<UploadImage
												document={getImageData(
													multipleImageData,
													docType.MATERIAL_FEATURE_IMAGE
												)}
												title="Back side folded & Feature image (-B)"
												docType={docType.MATERIAL_FEATURE_IMAGE}
												removeImage={removeImage}
												singleImageUpload={singleImageUpload}
											/>

											<UploadImage
												document={getImageData(
													multipleImageData,
													docType.MATERIAL_DETAILS_IMAGE
												)}
												title="Details (-D)"
												docType={docType.MATERIAL_DETAILS_IMAGE}
												removeImage={removeImage}
												singleImageUpload={singleImageUpload}
											/>
											<div className="dashboard-container material-images-uplodaer d-flex align-items-center justify-content-center">
												<div className="presentations-tab">
													<div className="inline-upload text-center">
														<label htmlFor="multipleUploadParent">
															Upload all
														</label>
														<input
															type="file"
															className="file-upload"
															id="multipleUploadParent"
															name="image1"
															onClick={(e) => (e.target.value = null)}
															onChange={(e) => onFileUpload(e)}
															accept="image/*"
															multiple={true}
														/>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div className="common-fragment">
								<div className="container px-0">
									<div className="row">
										<div className="col-md-12">
											<p className="semibold-14 mb-2">FABRIC DETAILS</p>
										</div>
										<div className="col-md-6 pr-10">
											<div className="row">
												<div className="col-md-12">
													<div className="form-group fabric-sub-category select-component">
														<label htmlFor="fabricType">Fabric type*</label>
														<FabricSubCategory
															onSelectCallBack={(value) =>
																setSelectedItem({
																	...selectedItem,
																	construction: value
																})
															}
															type={'INPUT'}
															isEditable={true}
															previousValue={`${capitalizeFirstLetter(
																`${
																	selectedFabricToEdit?.fabricType ||
																	'Select Fabric type'
																}${
																	selectedFabricToEdit?.groupName
																		? ` - ${selectedFabricToEdit.groupName}`
																		: ''
																}${
																	selectedFabricToEdit?.name
																		? ` - ${selectedFabricToEdit.name}`
																		: ''
																}`
															)}`}
															isAddNew={checkAnyUserType(['ADMIN'])}
															onAddNew={onAddNew}
															isFabricTypeModify={isFabricTypeModify}
															onEditFabricType={onEditFabricType}
															selectedFabricTypeToEdit={
																selectedFabricTypeToEdit
															}
															fabricTypeList={fabricTypeResponse}
															setFabricTypeList={setFabricTypeResponse}
														/>
														{errors2?.constructionError && (
															<p className="error">
																{errors2?.constructionError}
															</p>
														)}
													</div>
													{(isAddNew || selectedFabricTypeToEdit) && (
														<AddNewFabricType
															fabricTypeList={fabricTypeList}
															setIsAddNew={setIsAddNew}
															addNewValue={
																selectedFabricTypeToEdit
																	? selectedFabricTypeToEdit?.name
																	: addNewValue
															}
															setNewFabricType={setNewFabricType}
															setIsLoading={setIsLoading}
															selectedFabricTypeToEdit={
																selectedFabricTypeToEdit
															}
															setSelectedFabricTypeToEdit={
																setSelectedFabricTypeToEdit
															}
															setFabricTypeList={setFabricTypeResponse}
														/>
													)}
												</div>
												<div className="col-md-12">
													<label htmlFor>Composition *</label>
												</div>
												<div className="col-md-12 compositions-list">
													<div className="row">
														{compositionFieldInfoList?.map((obj, index) =>
															compositionRender(obj, index)
														)}
													</div>
												</div>

												<div className="col-md-12 compositonError">
													{errors?.compositionError && (
														<p className="error">{errors.compositionError}</p>
													)}
												</div>

												<div className="col-md-6 pr-6">
													<div className="form-group weight-column position-relative">
														<label htmlFor="GSM">Weight*</label>
														<div className="d-flex">
															<input
																type="number"
																id="GSM"
																min={0}
																onKeyDown={validateFloatNumber}
																value={selectedItem?.gsm}
																className="weight-input"
																onChange={(e) =>
																	setSelectedItem({
																		...selectedItem,
																		gsm: e.target.value
																	})
																}
															/>

															<div className="weight-dropdown">
																<div className="form-group size36 mb-0">
																	<CustomDropdown
																		type="fabricName"
																		title={'Select'}
																		items={WEIGHT_TYPES}
																		toolTipLength={13}
																		isShowSearch={false}
																		onItemClick={(item) =>
																			setSelectedWeightType(item)
																		}
																		selectedItem={
																			selectedWeightType?.value
																		}
																	/>
																</div>
															</div>
														</div>

														{errors2.gsmError && (
															<p className="error">{errors2.gsmError}</p>
														)}
													</div>
												</div>
												<div className="col-md-6 pl-6">
													<div className="form-group cuttable-width-column position-relative">
														<label htmlFor="GSM">Cuttable-width*</label>
														<div className="d-flex">
															<input
																type="text"
																id="cuttableWidth"
																value={selectedItem?.cuttableWidth}
																onChange={(e) =>
																	setSelectedItem({
																		...selectedItem,
																		cuttableWidth: e.target.value
																	})
																}
															/>

															<div className="cuttable-width-dropdown">
																<div className="form-group size36 mb-0">
																	<CustomDropdown
																		type="fabricName"
																		title={'Select'}
																		items={CUTTABLE_WIDTH_TYPES}
																		toolTipLength={13}
																		isShowSearch={false}
																		onItemClick={(item) =>
																			setCuttableWithType(item)
																		}
																		selectedItem={
																			cuttableWidthType?.value
																		}
																	/>
																</div>
															</div>
														</div>
														{errors2.cuttableWidthError && (
															<p className="error">
																{errors2.cuttableWidthError}
															</p>
														)}
													</div>
												</div>

												<div className="col-md-12">
													<div className="form-group">
														<label htmlFor="description">Remarks</label>
														<textarea
															name="description"
															id="description"
															placeholder="Write description"
															defaultValue={''}
															value={selectedItem?.description}
															onChange={(e) =>
																setSelectedItem({
																	...selectedItem,
																	description: e.target.value
																})
															}
														/>
													</div>
												</div>

												<div className="col-md-12">{renderColors()}</div>
												<div className="col-md-12">
													<div className="form-group stripe-details position-relative">
														<label htmlFor="GSM">Stripe details</label>
														<div className="d-flex">
															<div className="cuttable-width-dropdown">
																<div className="form-group size36 mb-0">
																	<CustomDropdown
																		type="stripeType"
																		title={'Select'}
																		items={STRIPE_TYPES}
																		toolTipLength={13}
																		isShowSearch={false}
																		onItemClick={(item) =>
																			setStripeType(item)
																		}
																		selectedItem={stripeType?.value}
																		isDisabled={colorType !== 'YARN_DYED'}
																	/>
																</div>
															</div>
															<input
																type="text"
																id="stripeTypeDetails"
																value={selectedItem?.stripeTypeDetails}
																onChange={(e) =>
																	setSelectedItem({
																		...selectedItem,
																		stripeTypeDetails: e.target.value
																	})
																}
																disabled={colorType !== 'YARN_DYED'}
																className="double-input left"
															/>
														</div>
														{errors2.stripeTypeError && (
															<p className="error">{errors2.stripeTypeError}</p>
														)}
													</div>
												</div>
											</div>
										</div>
										<div className="col-md-6 pl-10">
											<div className="row">
												<div className="col-md-12">
													<div className="form-group ">
														<label htmlFor="construction">Construction</label>
														<input
															type="text"
															id="construction"
															value={selectedItem?.constructionDetails}
															onChange={(e) =>
																setSelectedItem({
																	...selectedItem,
																	constructionDetails: e.target.value
																})
															}
														/>
													</div>
												</div>
												<div className="col-md-4 pr-6">
													<div className="form-group pair-fabric-code">
														<label htmlFor="drappy">Drappy</label>
														<div className="form-group size36 mb-0">
															<CustomDropdown
																type="fabricName"
																title={'Select'}
																items={tags.drappy}
																toolTipLength={13}
																isShowSearch={false}
																onItemClick={(item) =>
																	setSelectedDrappy(item)
																}
																selectedItem={selectedDrappy?.value}
															/>
														</div>
													</div>
												</div>
												<div className="col-md-4 pl-6 pr-6">
													<div className="form-group pair-fabric-code">
														<label htmlFor="handFeel">Hand Feel</label>
														<div className="form-group size36 mb-0">
															<CustomDropdown
																type="fabricName"
																title={'Select'}
																items={tags.handFeel}
																toolTipLength={13}
																isShowSearch={false}
																onItemClick={(item) =>
																	setSelectedHandFeel(item)
																}
																selectedItem={selectedHandFeel?.value}
															/>
														</div>
													</div>
												</div>
												<div className="col-md-4 pl-6">
													<div className="form-group pair-fabric-code">
														<label htmlFor="finishEffect">Finish Effect</label>
														<div className="form-group size36 mb-0">
															<CustomDropdown
																type="fabricName"
																title={'Select'}
																items={tags.finishEffect}
																toolTipLength={13}
																isShowSearch={false}
																onItemClick={(item) =>
																	setSelectedFinishEffect(item)
																}
																selectedItem={selectedFinishEffect?.value}
															/>
														</div>
													</div>
												</div>
												<div className="col-md-6 pr-6">
													<div className="form-group pair-fabric-code">
														<label htmlFor="finishEffect">Look</label>
														<div className="form-group size36 mb-0">
															<CustomDropdown
																type="fabricName"
																title={'Select'}
																items={tags.look}
																toolTipLength={13}
																isShowSearch={false}
																onItemClick={(item) => setSelectedLook(item)}
																selectedItem={selectedLook?.value}
															/>
														</div>
													</div>
												</div>
												<div className="col-md-6 pl-6">
													<div className="form-group no-shadow-react-select size36">
														<label htmlFor="fabricBase">Finish & wash</label>
														{renderFinishField()}
													</div>
												</div>
												<div className="col-md-4 pr-6">
													<div className="form-group no-shadow-react-select size36">
														<label htmlFor="fabricBase">Fabric base</label>
														<Select
															key={_getKey()}
															onChange={setFabricBase}
															defaultValue={fabricBase}
															isMulti={false}
															isDisabled={false}
															options={FABRIC_BASE_LIST}
														/>
													</div>
												</div>
												<div className="col-md-4 pl-6 pr-6">
													<div className="form-group no-shadow-react-select size36">
														<label htmlFor="priceRange">Price range</label>
														<Select
															key={_getKey()}
															onChange={onPriceRangeClick}
															defaultValue={pricePoint}
															isMulti={false}
															isDisabled={false}
															options={PRICE_POINT_LIST}
														/>
													</div>
												</div>
												<div className="col-md-4 pl-6">
													<div className="form-group no-shadow-react-select size36">
														<label htmlFor="nitexRND">Nitex R&D</label>
														<Select
															key={_getKey()}
															onChange={setNitexRND}
															defaultValue={nitexRND}
															isMulti={false}
															isDisabled={false}
															options={NITEX_RND_LIST}
														/>
													</div>
												</div>
												<div className="col-md-12">
													<div className="form-group">
														<label htmlFor="fabricFormula">Fabric formula</label>
														<textarea
															name="fabricFormula"
															id="fabricFormula"
															placeholder="Write Fabric formula"
															defaultValue={''}
															value={selectedItem?.fabricFormula}
															onChange={(e) =>
																setSelectedItem({
																	...selectedItem,
																	fabricFormula: e.target.value
																})
															}
														/>
													</div>
												</div>
												<div className="col-md-12">
													<div className="form-group pattern-dropdown">
														<label htmlFor="pattern">Pattern*</label>
														<div className="form-group size36 mb-0">
															<CustomDropdown
																type="fabricName"
																title={'Select Solid/ Pattern'}
																items={allPatterns}
																customDesign={(item) => getPatternCard(item)}
																toolTipLength={13}
																isShowSearch={true}
																onItemClick={(item) =>
																	setSelectedPattern(item)
																}
																selectedItem={
																	selectedPattern?.value ||
																	selectedPattern?.name
																}
																selectedImage={
																	selectedPattern?.documentResponse?.docUrl
																}
																isDisabled={colorType === 'SOLID'}
															/>
															{errors2?.patternError && (
																<p className="error">
																	{errors2?.patternError}
																</p>
															)}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							{/* Supplier Details */}

							<div className="common-fragment mt-3">
								<div className="container px-0">
									<div className="row">
										<div className="col-md-12">
											<p className="semibold-14 mb-2">SUPPLIER DETAILS</p>
										</div>
										<div className="col-md-6 pr-10">
											<div className="row">
												<div className="col-md-12">
													<div className="form-group">
														<label htmlFor="supplier">Supplier*</label>
														<CustomDropdown
															type="addItem"
															title={'Supplier'}
															onItemClick={onItemClick}
															items={suppliers}
															selectedItem={selectedSupplier?.value}
														/>
														{errors2.supplierDetailsError && (
															<p className="error">
																{errors2.supplierDetailsError}
															</p>
														)}
													</div>
												</div>
												<div className="col-md-6 pr-6">
													<div className="form-group">
														<label htmlFor="refNumber">
															Supplier fabric ref number
														</label>
														<input
															type="text"
															id="refNumber"
															className="form-control"
															aria-label="Text input with dropdown button"
															placeholder=""
															value={referenceNumber}
															onChange={(e) =>
																setReferenceNumber(e.target.value)
															}
														/>
													</div>
												</div>
												<div className="col-md-6 pl-6">
													<div className="form-group">
														<label htmlFor="isImported">
															Is it imported fabric? *
														</label>
														<CustomDropdown
															type="imported"
															title={'Select'}
															items={[
																{ id: 'YES', value: 'Yes' },
																{ id: 'NO', value: 'No' }
															]}
															isShowSearch={false}
															onItemClick={(item) => setIsImported(item)}
															selectedItem={isImported?.value}
														/>
														{errors2.importError && (
															<p className="error">{errors2.importError}</p>
														)}
													</div>
												</div>
												<div className="col-md-12">
													<div className="form-group no-shadow-react-select size36">
														<label htmlFor="brand">Developed for (Brand)?</label>
														<Select
															key={_getKey()}
															onChange={onChangeBrandInfo}
															isMulti
															options={brands}
															defaultValue={selectedBrands}
														/>
													</div>
												</div>
											</div>
										</div>
										<div className="col-md-6 pl-10">
											<div className="row">
												<div className="col-md-12">
													<div className="form-group">
														<label htmlFor="chalan">Chalan*</label>
														<input
															type="text"
															value={chalanNo}
															onChange={(e) => setChalanNo(e.target.value)}
														/>
														{errors2.chalanError && (
															<p className="error">{errors2.chalanError}</p>
														)}
													</div>
												</div>
												<div className="col-md-12">
													<div className="form-group">
														<label htmlFor="invoiceNo">Invoice No.</label>
														<input
															type="text"
															value={invoiceNo}
															onChange={(e) => setInvoiceNo(e.target.value)}
														/>
														{errors2.invoiceError && (
															<p className="error">{errors2.invoiceError}</p>
														)}
													</div>
												</div>
												<div className="col-md-6 pr-6">
													<div className="form-group purchase-price-column position-relative">
														<label htmlFor="purchasePrice">Purchase price</label>
														<div className="d-flex">
															<input
																type="number"
																id="purchasePrice"
																className="double-input"
																min={0}
																value={purchasePrice}
																placeholder="$"
																onChange={(e) =>
																	setPurchasePrice(e.target.value)
																}
															/>

															<div className="purchase-price-dropdown">
																<div className="form-group size36 mb-0">
																	<CustomDropdown
																		type="fabricName"
																		title={'Select'}
																		items={PURCHASE_PRICE_TYPES}
																		toolTipLength={13}
																		isShowSearch={false}
																		onItemClick={(item) =>
																			setPurchasePriceCurrencyType(item)
																		}
																		selectedItem={
																			purchasePriceCurrencyType?.value
																		}
																	/>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div className="col-md-6 pl-6">
													<div className="form-group fabric-qty-column position-relative">
														<label htmlFor="fabricQty">Fabric qty</label>
														<div className="d-flex">
															<input
																type="text"
																id="fabricQty"
																className="double-input"
																value={fabricQty}
																onChange={(e) => setFabricQty(e.target.value)}
															/>

															<div className="fabric-qty-dropdown">
																<div className="form-group size36 mb-0">
																	<CustomDropdown
																		type="fabricName"
																		title={'Select'}
																		items={FABRIC_QTY_TYPES}
																		toolTipLength={13}
																		isShowSearch={false}
																		onItemClick={(item) =>
																			setFabricQtyType(item)
																		}
																		selectedItem={fabricQtyType?.value}
																	/>
																</div>
															</div>
														</div>
													</div>
												</div>
												{fabricDetails?.data?.lastUpdateDate && (
													<div className="col-md-12">
														<p className="regular-12 gray_dark_01">
															Last update:{' '}
															<span className="gray_dark_03">
																{changeDateFormat(
																	fabricDetails?.data?.lastUpdateDate,
																	'YYYY-MM-DD',
																	'DD MMM, YYYY'
																)}
																25 Mar, 2024, Imran
															</span>
														</p>
													</div>
												)}
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="common-fragment mt-3">
								<MaterialRoadmap
									roadmapInput={roadmapInput}
									onChangeMaterialRoadmap={onChangeMaterialRoadmap}
									suppliers={suppliers}
									setRoadmapInput={setRoadmapInput}
									selectedSupplier={selectedSupplier}
									errors={errors2?.materialRoadmapError}
								/>
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<div className="footer-buttons text-right">
							<button className="button outline size32" onClick={() => handleClose('Cancel')}>
								Cancel
							</button>
							<button
								disabled={isLoading}
								className="button size32 ml-2"
								onClick={() => onSubmit()}
							>
								Submit
							</button>
						</div>
					</Modal.Footer>
				</div>
			</LoaderComponent>
		</Modal>
	);
};

export default Fabric;
